// extracted by mini-css-extract-plugin
module.exports = {"flex":"Amount_flex__2sJmE","icon":"Amount_icon__2F2oT","title":"Amount_title__3ffNW","value":"Amount_value__qAHk2"};